import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./index.css";

const directorsDetails = [
  {
    name: "Dr Eeshani Bendale",
    title: "WHO",
    imageUrl: "/assets/images/OxfordMunNew/eeshani_bendale.jpg",
    description:
      "Dr Eeshani Bendale is an Indian physician and researcher whose work bridges Ayurveda, Nanomedicine, and Evidence-based medicine. She recently completed an MSc in Evidence-Based Health Care at the University of Oxford and is passionate about equitable access to healthcare innovation. Dr Bendale's work focuses on fostering inclusive and interdisciplinary approaches to global health.",
  },
  {
    name: "Victoria Lawrence",
    title: "UNCSW",
    imageUrl: "/assets/images/OxfordMunNew/victoria_lawrence.jpg",
    description:
      "Victoria Lawrence is a first-year undergraduate at Merton College, Oxford University, studying French and Spanish. She took part in MUN in school, having attended multiple conferences in the UK, and chaired at her secondary school's MUN club. She has been a member of Oxford Global since arriving at Oxford, and chaired at both Oxford Global's OxfordMUN Home Conference 2024 and NoviceNations 2025. She is now one of the Under Secretary-Generals for Content in the OxfordMUN 2025 Home Conference.",
  },
  {
    name: "Abhipsa Panda",
    title: "UNOOSA",
    imageUrl: "/assets/images/OxfordMunNew/abhipsa_panda.jpg",
    description:
      "Abhipsa Panda (She/Her) is a first-year undergraduate studying Economics and Management at St Edmund Hall, Oxford. She’s chaired and hosted several MUN conferences in the past, and has dabbled in competitive public speaking since middle school. Outside of MUN, she enjoys singing, playing the piano and guitar, and late night stargazing. She’s also on a mission to find the best coffee shop in Oxford—though a cheap cup from Greggs is currently undefeated.",
  },
  {
    name: "Aaron Freedman",
    title: "Director General",
    imageUrl: "/assets/images/OxfordMunNew/aaron_freedman.png",
    description:
      "Aaron Freedman (he/him) is a third-year student at The Queen’s College, Oxford, and is studying Japanese and Mandarin. He is currently focused on historical linguistics with the aim of translating ancient poetry for a modern audience. Outside of class, Aaron dances at the Salsa Society, and is slowly working through every café in Oxford in an attempt to find the city’s best sandwich. He is very much looking forward to meeting all of you at the India conference.",
  },
  {
    name: "Luca Moretto",
    title: "DISEC",
    imageUrl: "/assets/images/OxfordMunNew/luca_moret.png",
    description:
      "Luca Moretto is a second-year student at Lincoln College, University of Oxford. He is currently pursuing a BA in Ancient and Modern History and is undertaking a thesis focused on nationalism within the Irish film industry. Outside of his degree, he enjoys watching films and playing football and rugby. With his enthusiasm for diplomacy and cross-cultural dialogue, Luca is looking forward to an exciting conference with OxfordMUN India.",
  },
  {
    name: "Dr. Joana Perrone",
    title: "Secretary General",
    description:
      "Dr. Joana Perrone is an educator with experience in higher education, supercurricular activities and research skills. She has a BA in International Relations from the University of Sussex, a Masters in Women’s Studies, and a PhD in Area Studies from Wadham College, University of Oxford, which focused on feminicide in Brazil. Dr Perrone has been teaching at a variety of undergraduate and graduate programs at the university since 2019. Her book “Embodied Struggles”, on gender violence in Latin America will be published in early 2026.",
    imageUrl: "/assets/images/OxfordMunNew/joana_perrone.png",
  },
  {
    name: "Yassin",
    title: "UNEP",
    imageUrl: "/assets/images/OxfordMunNew/yassin.jpg",
    description:
      "Hi all! I’m Yassin, a 2nd year Philosophy, Politics and Economics (PPE) student at Trinity College, Oxford. I’m from the UK/Netherlands, and have been involved in foreign affairs societies and debating societies in my time at Oxford, including chairing at OxfordMUN since my first year of undergraduate. I look forward to seeing you all soon, and here’s hoping for a brilliant upcoming conference!",
  },
  {
    name: "Eain Lin Thu",
    title: "SOCHUM",
    imageUrl: "/assets/images/OxfordMunNew/eain_lin_thu.png",
    description:
      "Eain Lin Thu is a first year student studying Experimental Psychology at Jesus College, University of Oxford. She has many years of experience tutoring younger students, and is passionate about debate. Her interest in international relations drew her to MUN, and she also joined Oxford Global. Most recently, she’s been involved with OxfordMUN Home Conference 2024 and NoviceNations 2025, as well as being on the secretariat for the OxfordMUN 2025 conference. Outside of her degree, she has been getting involved in technical theatre and exploring different types of dance.",
  },
];

const SecretarySection = ({
  handleToggle = () => {},
  handleCounsollerToggle = () => {},
  // isMobile,
}) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalSlides = directorsDetails.length;
  const swiperRef = useRef(null);

  const navConfig = {
    prevEl: `.swiper-button-prev-secretary`,
    nextEl: `.swiper-button-next-secretary`,
  };

  // 🔁 When `isMobile` changes, re-bind swiper navigation
  // useEffect(() => {
  //   if (swiperRef.current && swiperRef.current.params?.navigation) {
  //     const swiper = swiperRef.current;

  //     swiper.params.navigation.prevEl = navConfig.prevEl;
  //     swiper.params.navigation.nextEl = navConfig.nextEl;

  //     swiper.navigation.destroy();
  //     swiper.navigation.init();
  //     swiper.navigation.update();
  //   }
  // }, [isMobile]);

  return (
    <div className="document-container">
      <div className="document-content">
        {/* Letter from Secretary General Section */}
        <section className="letter-section">
          <div className="letter-section-left">
            <h2 className="section-title">
              LETTER FROM THE
              <br />
              <span className="title-highlight">SECRETARY GENERAL</span>
            </h2>
            <div className="letter-section-img">
              <img
                src="/assets/images/OxfordMunNew/joana_perrone_sg.png"
                alt="SECRETARY GENERAL"
              />
            </div>
          </div>
          <div className="letter-content">
            <div className="letter-section-img-large">
              <img
                src="/assets/images/OxfordMunNew/joana_perrone_sg.png"
                alt="SECRETARY GENERAL"
              />
            </div>
            <div className="content-application">
              <p>
                <strong>Dear Delegates and Faculty Advisors,</strong>
              </p>
              <p>
                It is with immense pride and anticipation that we welcome you to
                <strong> OxfordMUN India 2025</strong>, hosted at the
                distinguished <strong>FLAME University, Pune</strong>, this
                October.
              </p>
              <p>
                As Secretary-General, I invite you to a conference shaped by
                intellectual rigour, diplomatic nuance, and a deep respect for
                diverse perspectives. This year’s committees will engage with
                some of the world’s most urgent challenges, each agenda chosen
                to inspire critical thought and collaborative action.
              </p>
              <p>
                Beyond debate, OxfordMUN India offers an immersive journey where
                ideas are sharpened, identities are shaped, and connections
                transcend borders
              </p>
              <p>
                We urge you to prepare not only with depth, but with curiosity
                and courage. Step into committee not just to speak, but to
                understand, challenge, and lead.
              </p>
              <p>
                We look forward to hosting you for a conference that promises
                substance, reflection, and lasting impact.
              </p>
              <div className="signature">
                <p>
                  Warm regards,
                  <br />
                  <strong>Joana Perrone</strong>
                  <br />
                  Secretary-General
                  <br />
                  OxfordMUN India 2025
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Directors Section */}
        <section className="directors-section">
          <div className="directors-header-section">
            <h2 className="section-title">OUR DIRECTORS</h2>
            {/* Custom Bottom Controls */}
            <div className="custom-bottom-nav-mobile">
              <div className="custom-arrow swiper-button-prev-secretary">
                &#8592;
              </div>
              <div className="slide-counter">
                {currentSlide} / {totalSlides}
              </div>
              <div className="custom-arrow swiper-button-next-secretary">
                &#8594;
              </div>
            </div>
          </div>
          <div className="directors-grid">
            <Swiper
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              breakpoints={{
                // 1440: { slidesPerView: 4, spaceBetween: 40 },
                1024: { slidesPerView: 3, spaceBetween: 30 },
                900: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 1, spaceBetween: 10 },
              }}
              modules={[Navigation, Autoplay, A11y]}
              // navigation
              navigation={navConfig}
              onInit={(swiper) => {
                swiper.params.navigation.prevEl = navConfig.prevEl;
                swiper.params.navigation.nextEl = navConfig.nextEl;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              onSlideChange={(swiper) => {
                setCurrentSlide(swiper.realIndex + 1);
              }}
              autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
              loop
            >
              {directorsDetails.map((details, idx) => (
                <SwiperSlide key={idx} className="director-slide">
                  <div
                    className="director-card"
                    style={
                      currentSlide - 1 === idx
                        ? {
                            borderLeft: 0,
                            paddingLeft: 0,
                          }
                        : {}
                    }
                  >
                    <div className="director-image-placeholder">
                      <img src={details.imageUrl} alt="director img" />
                    </div>
                    <div className="director-info">
                      <h3 className="director-name">{details.name}</h3>
                      <h4 className="director-title">{details.title}</h4>
                      <p className="director-description">
                        {details.description}
                      </p>
                    </div>
                  </div>
                  {/* <div className="border-right"></div> */}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {/* Custom Bottom Controls
          <div className="custom-bottom-nav">
            <div className="custom-arrow swiper-button-prev-desktop-secretary">
              &#8592;
            </div>
            <div className="slide-counter">
              {currentSlide} / {totalSlides}
            </div>
            <div className="custom-arrow swiper-button-next-desktop-secretary">
              &#8594;
            </div>
          </div> */}
        </section>

        {/* What is Model United Nations Section */}
        <section className="mun-section">
          <div className="header-mun_modal">
            <h2 className="section-title">
              WHAT IS MODEL
              <br />
              UNITED NATIONS?
            </h2>
            <div className="buttons-section">
              <button className="primary-btn" onClick={handleToggle}>
                REGISTER NOW
              </button>
              <a
                className="secondary-btn"
                href="https://bit.ly/OxfordMUNIndia2025Brochure"
                target="_blank"
              >
                DOWNLOAD BROCHURE
              </a>
              <button className="primary-btn" onClick={handleCounsollerToggle}>
                CONNECT WITH A COUNSELLOR
              </button>
            </div>
          </div>

          <div className="mun-content">
            <p>
              Model United Nations (MUN) is a globally recognized simulation of
              diplomatic engagement, a space where students embody the roles of
              international delegates, navigating the delicate balance between
              national interest and global cooperation. Assigned to represent
              countries or political entities, participants engage in high-level
              discourse on some of the world’s most pressing issues.
            </p>
            <p>
              Each delegate must research, articulate, and negotiate from the
              perspective of their assigned country. Whether it’s a conflict
              resolution in the Security Council or a development strategy in
              the UNDP, every stance taken must align with real-world policies
              and priorities.
            </p>
            <p>
              Throughout the process, students debate, draft resolutions, form
              alliances, lobby for support, and vote on global solutions, all
              while adhering to parliamentary procedure and the spirit of
              diplomacy.
            </p>
            <p>
              But beyond the formalities, MUN offers something more powerful: an
              understanding of how global governance works and a chance to build
              the skills that matter: negotiation, critical thinking,
              collaboration, and public speaking.
            </p>
            More than a classroom or a stage, MUN is where young people begin to
            see the world differently and discover how they can shape it.
            <p></p>
          </div>
          <div className="buttons-section">
            <button className="primary-btn" onClick={handleToggle}>
              REGISTER NOW
            </button>
            <a
              className="secondary-btn"
              href="https://bit.ly/OxfordMUNIndia2025Brochure"
              target="_blank"
            >
              DOWNLOAD BROCHURE
            </a>
            <button className="primary-btn" onClick={handleCounsollerToggle}>
              CONNECT WITH A COUNSELLOR
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SecretarySection;
